import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import config from "../config";
class StudentBusAssignmentStore {

    total = 0
    studentAssignmentStore = []
    summary = []
    loading = false

    constructor(rootStore) {
        makeObservable(this, {
        total: observable,
        studentAssignmentStore: observable,
        summary: observable,
        loadData: action,
        loading: observable
        });
    }

    async loadData({ companyId, vehicleId, garage, fromVehicleLocation, offset, limit, pageNo }) {

        this.loading = true

        var postData = {
            companyId: companyId,
            vehicleId: vehicleId,
            MAX_DISTANCE_KM: 13,
            garage: garage,
            fromVehicleLocation: fromVehicleLocation,
            offset: offset,
            limit: limit,
            page: pageNo,
        };
        
        var response = await postApi.getClient("").post(config.NodeUrl + "/passenger/assignBusToStudent", postData);
        // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/getStudentAssignmentList", postData);
        // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/assignBusToStudent", postData);

        this.studentAssignmentStore = response?.data?.data;
        this.studentAssignmentData= response?.data?.data.map((items)=>items.studentList);
        this.total = response?.data?.TotalCount;
        this.summary = response?.data?.summary;
        this.loading = false
    }

    async updateAssignVehicle(passengerData) {

        var response = await postApi.getClient("").post(config.NodeUrl + "/passenger/passengerData", passengerData);

        // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/updateAssignVehicle", passengerData);
        return response?.data;

    }

    async exportExcel(getData) {
        try {
            var response = await postApi.getClient("").post(config.NodeUrl + "/passenger/exportAssignAllVehicleExcel",getData,
                {
                responseType: "blob",
                }
            );

            // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/exportAssignAllVehicleExcel",getData,
            //     {
            //     responseType: "blob",
            //     }
            // );
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Student Assignment list.xlsx";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading the file", error);
        }
  }

  async exportStudentVehicleExcel(getData) {
        try {
            var response = await postApi.getClient("").post(config.NodeUrl + "/passenger/exportAssignVehicleExcel",getData,
                {
                responseType: "blob",
                }
            );

            // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/exportAssignVehicleExcel",getData,
            //     {
            //     responseType: "blob",
            //     }
            // );
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Student Vehicle Assignment list.xlsx";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading the file", error);
        }
  }

}

export default StudentBusAssignmentStore;
